import { ZodIssue } from 'zod'
import { Alert } from '@/common'
import { useTranslation } from 'react-i18next'
import { compact } from 'es-toolkit'

export default function FormErrorsAlert({
  errors,
  stringKeysPrefix = '',
  useZodMessageField = false
}: {
  errors: ZodIssue[]
  stringKeysPrefix?: string
  useZodMessageField?: boolean
}) {
  const { t } = useTranslation()
  const generateErrorKey = (errorPath: PropertyKey[], errorCode: string, message: string) =>
    useZodMessageField
      ? compact([stringKeysPrefix, errorPath.map(String).join('.'), 'errors', message]).join('.')
      : compact([stringKeysPrefix, errorPath.map(String).join('.'), 'errors', errorCode]).join('.')

  const generateLabelKey = (errorPath: PropertyKey[]) =>
    compact([stringKeysPrefix, errorPath.map(String).join('.'), 'label']).join('.')

  if (errors.length === 0) {
    return null
  }

  return (
    <Alert type="error">
      {errors.map(error => (
        <div key={generateErrorKey(error.path, error.code, error.message)}>
          <span className="underline">{t(generateLabelKey(error.path))}</span>:{' '}
          {t(generateErrorKey(error.path, error.code, error.message))}
        </div>
      ))}
    </Alert>
  )
}
